import { ROLES } from '@/constants/roles';

export const userLogin = {
  path: '/user-login',
  name: 'user-login',
  component: () => import('@/modules/Admin/views/admin-user-login.vue'),
  meta: {
    buttonTitle: 'Авторизация',
    title: 'Авторизация под пользователем',
    icon: 'mdi-exit-run',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const userSearch = {
  path: '/user-search',
  name: 'user-search',
  component: () => import('@/modules/Admin/views/admin-user-search.vue'),
  meta: {
    title: 'Поиск пользователя',
    icon: 'mdi-account-search',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const userRecovery = {
  path: '/user-recovery',
  name: 'user-recovery',
  component: () => import('@/modules/Admin/views/admin-user-recovery.vue'),
  meta: {
    title: 'Список пользователей',
    icon: 'mdi-account',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const memberChangePage = {
  path: '/member-recovery/:id',
  name: 'member-recovery-id',
  component: () => import('@/modules/Admin/components/admin-user-change-pages/AdminMemberChangePage.vue'),
  meta: {
    title: 'Изменение пользователя',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const organizationChangePage = {
  path: '/organization-recovery/:id',
  name: 'organization-recovery-id',
  component: () => import('@/modules/Admin/components/admin-user-change-pages/AdminOrganizationChangePage.vue'),
  meta: {
    title: 'Изменение организации',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const expertChangePage = {
  path: '/expert-recovery/:id',
  name: 'expert-recovery-id',
  component: () => import('@/modules/Admin/components/admin-user-change-pages/AdminExpertChangePage.vue'),
  meta: {
    title: 'Изменение эксперта',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const trainerChangePage = {
  path: '/trainer-recovery/:id',
  name: 'trainer-recovery-id',
  component: () => import('@/modules/Admin/components/admin-user-change-pages/AdminTrainerChangePage.vue'),
  meta: {
    title: 'Изменение тренера',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const allDuplicatePage = {
  path: '/all-duplicates',
  name: 'all-duplicates',
  component: () => import('@/modules/Admin/components/admin-user-duplicate/AdminAllDuplicatePage.vue'),
  meta: {
    title: 'Поиск дубликатов',
    accessList: [ROLES.admin],
    icon: 'mdi-account-search',
    layout: 'ui-design',
  },
};

export const sameDuplicatePage = {
  path: '/same-duplicate/:id',
  name: 'same-duplicate-id',
  component: () => import('@/modules/Admin/components/admin-user-duplicate/AdminSameDuplicatePage.vue'),
  meta: {
    back: true,
    title: 'Поиск дубликата',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const eventsPage = {
  path: '/admin/events',
  name: 'admin-events',
  component: () => import('@/modules/Admin/views/admin-events.vue'),
  meta: {
    title: 'Управление мероприятиями',
    accessList: [ROLES.admin],
    icon: 'mdi-calendar',
    layout: 'ui-design',
    back: true,
  },
};

export const eventGlobalAttributesPage = {
  path: '/admin/event-global-attributes',
  name: 'admin-event-global-attributes',
  component: () => import('@/modules/Admin/views/admin-event-global-attributes.vue'),
  meta: {
    title: 'Системные атрибуты и документы',
    icon: 'mdi-form-textbox',
    accessList: [ROLES.admin],
    layout: 'ui-design',
    back: true,
  },
};

export const operatorLogin = {
  path: '/operator-login',
  name: 'operator-login',
  component: () => import('@/modules/Admin/views/admin-operator-login.vue'),
  meta: {
    title: 'Войти под оператором',
    icon: 'mdi-exit-run',
    accessList: [ROLES.admin],
    layout: 'ui-design',
    back: true,
  },
};

export const eventTemplates = {
  path: '/event-templates',
  name: 'event-templates',
  component: () => import('@/modules/Admin/views/admin-event-templates.vue'),
  meta: {
    title: 'Шаблоны мероприятий',
    icon: '$icalendar',
    accessList: [ROLES.admin],
    layout: 'ui-design',
    back: true,
  },
};

export const adminEventAssociations = {
  path: '/event-associations',
  name: 'event-associations',
  component: () => import('@/modules/Admin/views/admin-associations.vue'),
  meta: {
    title: 'Ассоциации',
    icon: '$icalendar',
    accessList: [ROLES.admin],
    layout: 'ui-design',
  },
};

export const adminEventRecommendations = {
  path: '/event-recommendations',
  name: 'event-recommendations',
  component: () => import('@/modules/Admin/views/admin-event-recommendations.vue'),
  meta: {
    title: 'Рекомендации мероприятий',
    icon: '$ui-scale',
    accessList: [ROLES.admin],
    layout: 'ui-design',
    back: true,
  },
};

const routes = [
  userLogin,
  userSearch,
  userRecovery,
  memberChangePage,
  organizationChangePage,
  expertChangePage,
  trainerChangePage,
  allDuplicatePage,
  sameDuplicatePage,
  eventsPage,
  eventGlobalAttributesPage,
  eventTemplates,
  adminEventAssociations,
  adminEventRecommendations,
  operatorLogin,
];

export default routes;
